import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { PenaltyService } from '@service/syndic/penalty.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-penalty-add',
  templateUrl: './penalty-add.component.html',
  styleUrls: ['./penalty-add.component.scss']
})
export class PenaltyAddComponent implements OnInit {
  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  penalty: any;
  title: string = '';

  typesPenalite = [
    { label: 'Pourcentage fixe', value: 'POURCENTAGE_FIXE' },
    { label: 'Pourcentage mensuel', value: 'POURCENTAGE_MENSUEL' },
    { label: 'Pourcentage journalier', value: 'POURCENTAGE_JOURNALIER' },
    { label: 'Montant fixe', value: 'MONTANT_FIXE' }
  ];

  statuts = [
    { label: 'En cours', value: 'EN_COURS' },
    { label: 'Payé', value: 'PAYE' },
    { label: 'Annulé', value: 'ANNULE' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private penaltyService: PenaltyService,
    private syndicService: SyndicService
  ) {
    this.edit = this.penaltyService.edit;
    this.penalty = this.penaltyService.getPenalty();
    const ref = this.penalty ? this.penalty.reference : '';
    this.title = (!this.edit) ? 'Ajouter une pénalité' : 'Modifier la pénalité ' + ref;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.penalty) { this.setFormValue(); }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      reference: [null],
      montantImpayeBase: [0, [Validators.required]],
      tauxApplique: [0],
      typePenalite: ['POURCENTAGE_FIXE', [Validators.required]],
      joursRetard: [0],
      montantPenalite: [0],
      montantPaye: [0],
      statut: ['EN_COURS'],
      genereAutomatiquement: [true],
      dateCalcul: [null],
      description: [null],
      ownerCo: [null],
      fundsApeal: [null],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.penalty.uuid,
      reference: this.penalty.reference,
      montantImpayeBase: this.penalty.montantImpayeBase,
      tauxApplique: this.penalty.tauxApplique,
      typePenalite: this.penalty.typePenalite,
      joursRetard: this.penalty.joursRetard,
      montantPenalite: this.penalty.montantPenalite,
      montantPaye: this.penalty.montantPaye,
      statut: this.penalty.statut,
      genereAutomatiquement: this.penalty.genereAutomatiquement,
      dateCalcul: this.penalty.dateCalcul,
      description: this.penalty.description,
      ownerCo: this.penalty.ownerCo?.uuid,
      fundsApeal: this.penalty.fundsApeal?.uuid,
      trustee: this.penalty.trustee?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.penaltyService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'PENALTY_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'PENALTY_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void { this.modal.close('ferme'); }
  get f() { return this.form.controls; }
}
